import React from 'react';
import styled from 'styled-components';
import { Tooltip, token } from '@bynder/design-system';
import { useTranslate } from '@bynder/localization';
import { IconClear } from '@bynder/icons';

type Props = {
	onClick: (event: React.MouseEvent) => void;
};

export function ClearButton({ onClick }: Props) {
	const { translate } = useTranslate();
	const label = translate('spotlight.redesign.clearInput');

	return (
		<Tooltip content={label} timing="delay">
			{(triggerProps) => (
				<StyledButton
					{...triggerProps}
					type="button"
					aria-label={label}
					onClick={onClick}
					data-testid="spotlightClearButton"
				>
					<IconClear />
				</StyledButton>
			)}
		</Tooltip>
	);
}

const StyledButton = styled.button`
	padding: 0;
	border: none;
	background: transparent;
	color: ${token.gray200a};
	cursor: pointer;

	&:hover,
	&:focus {
		outline: none;
		color: ${token.gray300a};
	}

	&:active {
		color: ${token.gray400a};
	}
`;
